import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgForm, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
	selector: 'playout-details-sharing',
	templateUrl: './playout-details-sharing.component.html',
	styleUrls: ['./playout-details-sharing.component.scss']
})


export class PlayoutDetailsSharingComponent implements OnInit, AfterViewInit, OnDestroy {

	@Input() playout: any;
	@Input() form: NgForm;
	@Input() previewPlayer: any;

	use2018skin: boolean;

	subscriptions: Subscription;

	constructor() {
		this.subscriptions = new Subscription();
	}

	ngOnInit() {
		if (this.playout) {
			this.use2018skin = this.playout.use2018skin === 'true';
		}
	}

	ngAfterViewInit() {
		if (this.form && this.form.form) {
			const form: UntypedFormGroup = this.form.form;
			if (form.valueChanges) {
				this.subscriptions.add(form.valueChanges.subscribe((valueChanges) => {
					if (valueChanges && valueChanges['playout-use2018skin']) {
						this.use2018skin = valueChanges['playout-use2018skin'] === 'true';
					}
				}));
			}
		}
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}

}
